// Localization strings for MatrixReportGenerator (PTR FR / PTR EN)

export const STRINGS = {
  fr: {
    pdfTitle: "Plan de Traitement des Risques",
    pdfSubject: "EBIOS RM - Synthèse des Risques",
    pdfKeywords: "EBIOS RM, Matrice, Risques, Cadrage, Socle, Sources, Associations, Écosystème, Scénarios",

    cover: {
      program: "Programme :",
      analysis: "Analyse des risques – EBIOS RM",
      internal: "Interne",
      docType: "Document :",
      docTitle: "Plan de Traitement des Risques",
      docSubtitle: "Matrice de Traitement des Risques & Synthèse",
      version: "Version :",
      reference: "Référence :",
      scope: "Périmètre de l'analyse :",
      organization: "Organisation :",
      date: "Date :",
      status: "Statut :",
      statusValidated: "Validé",
    },

    common: {
      dash: "—",
      yes: "Oui",
      no: "Non",
      low: "Faible",
      medium: "Moyen",
      high: "Élevé",
      critical: "Critique",
      done: "Fait",
      inProgress: "En cours",
      planned: "Planifié",
      abandoned: "Abandonnée",
      infoNotAvailable: "Non renseigné",
      descNotAvailable: "Description non disponible",
      unknown: "Inconnu",
    },

    summary: {
      title: "0. SYNTHÈSE EXÉCUTIVE",
      studySubject: "Sujet de l'étude",
      studyOn: (name) => `L'étude porte sur : ${name}.`,
      noDesc: "Aucune description fournie.",
      assumptionsConstraints: "Principales hypothèses et contraintes",
      identifiedConstraints: "Contraintes identifiées :",
      workingAssumptions: "Hypothèses de travail :",
      andOthers: (n) => `... (et ${n} autres)`,
      noAssumptions: "Aucune hypothèse ou contrainte majeure spécifiée.",
      initialRisks: "Risques Inhérents / Initiaux",
      deSeverityDist: "Répartition des Événements Redoutés par gravité (avant traitement) :",
      severityHeaders: ["Gravité", "Nombre"],
      catCritical: "Catastrophique / Critique",
      major: "Majeure",
      modMinor: "Modérée / Mineure",
      treatmentPlan: "Principaux éléments du plan de traitement",
      treatmentAddressesScenarios: (n) => `Le plan de traitement adresse ${n} scénarios stratégiques.`,
      measuresInclude: "Les mesures de sécurité incluent des mesures préventives, de protection, de récupération et de gouvernance.",
      residualRisks: "Risques Résiduels",
      residualWarning: (n) => `Attention : Il subsiste ${n} scénarios conservant un niveau de risque élevé à moyen terme.`,
      residualAcceptable: "L'application du plan de traitement permet de ramener l'ensemble des risques à des niveaux acceptables à moyen terme.",
    },

    w1: {
      title: "1. ATELIER 1 : CADRAGE ET SOCLE DE SECURITE",
      infoTitle: "1.1. Informations relatives à l'étude",
      infoHeaders: ["Information", "Valeur"],
      version: "Version",
      date: "Date",
      status: "Statut",
      inProgress: "En cours",
      classification: "Classification",
      internal: "Interne",
      scopeTitle: "1.2. Périmètre métier et technique",
      systemPresentation: "1.2.1. Présentation du système",
      missions: "1.2.2. Missions",
      businessValues: "1.2.3. Valeurs Métier",
      bvDescription: "Cette section détaille les valeurs métier essentielles identifiées pour le périmètre d'étude, avec leur nature (processus ou information), leur propriétaire et une description.",
      bvHeaders: ["Valeur Métier", "Nature", "Propriétaire", "Description"],
      natureProcess: "Processus",
      natureInfo: "Information",
      supportingAssets: "1.2.4. Biens Supports",
      saDescription: (n) => `Cette section présente l'inventaire détaillé des ${n} biens supports identifiés, organisés par valeur métier. Ces actifs techniques représentent l'ensemble des composants nécessaires au fonctionnement des processus métier de l'organisation.`,
      saHeaders: ["ID", "Nom", "Type", "Propriétaire", "Localisation", "Fournisseur/Produit", "Version"],
      saDistTitle: "Répartition par type d'actif :",
      generalInfo: "1.2.5. Informations Générales",
      assumptions: "Hypothèses",
      constraints: "Contraintes",
      raciMatrix: "Matrice RACI",
      raciHeaders: ["Nom", "Rôle", "Contact"],
      respControls: "Responsables des Mesures de Contrôle",
      respHeaders: ["Fonction", "Rôle"],
      dreadedEventsSection: "1.3. Identification des événements redoutés",
      dreadedEventsTitle: "1.3.1. Événements redoutés",
      erHeaders: ["Valeur métier", "Pilier", "Événement Redouté", "Description/Impacts", "Gravité"],
      nonIntRisksTitle: "1.3.2. Risques non intentionnels",
      rnHeaders: ["Pilier", "Risque non intentionnel", "Description/Impacts", "Gravité"],
      noDreadedEvents: "Aucun événement redouté n'a été identifié.",
      bvDeRelTitle: "1.4. Relation entre les besoins de sécurité des valeurs métier et la gravité des événements redoutés",
      bvDeRelDesc: "Le tableau ci-après présente les relations entre les besoins de sécurité des valeurs métiers (VM) et la gravité des événements redoutés (ER).",
      relHeaders: ["Valeur métier", "Abrév.", "Besoins de sécurité", "Nom de l'évènement redouté", "Abrév.", "Gravité"],
      relInsufficient: "Données insuffisantes pour établir la relation.",
      baselineTitle: "1.5. Socle de sécurité",
      baselineDesc: "Le tableau ci-dessous présente les mesures de sécurité identifiées pour traiter les événements redoutés.",
      baselineHeaders: ["Règle / Événement", "Statut d'applicabilité", "Commentaire sur l'écart", "Justification", "Gravité", "Mesures de Contrôle", "Gravité Résiduelle"],
      rule: "Règle",
      event: "Événement",
      unknown: "Inconnu",
      nonIntRisk: "Risque non intentionnel",
      dreadedEvent: "Événement redouté",
      commentPrefix: "Commentaire :",
      controlPrefix: "Contrôle",
      decisionPrefix: "Décision:",
      responsiblePrefix: "Responsable:",
      noPlan: "Aucun plan de traitement associé aux événements redoutés identifiés.",
      noBaselineData: "Aucune donnée de traitement des risques disponible (socle de sécurité non défini).",
    },

    w2: {
      title: "2. ATELIER 2 : SOURCES ET SCÉNARIOS DE RISQUE",
      desc: "Cet atelier a pour objectif d'identifier les sources de risque et de construire les scénarios de risque identifiés.",
      sourcesTitle: "2.1. SOURCES DE RISQUE",
      sourcesDesc: "Cette section recense l'ensemble des acteurs malveillants potentiels (sources de risque) et leurs caractéristiques.",
      categoryPrefix: "Catégorie: ",
      sourcesHeaders: ["Nom", "Objectif Visé", "Type", "Motiv.", "Activ.", "Ress.", "Retenu"],
      noSources: "Aucune source de risque identifiée pour le moment.",
      assocTitle: "2.2. ASSOCIATIONS SR/ER",
      assocDesc: "Cette section présente les associations validées entre les Sources de Risque (SR) et les Événements Redoutés (ER).",
      assocHeaders: ["Source de Risque", "Objectif Visé", "Événement Redouté", "Niv. Menace", "Capacités SR", "Retenu", "Justification"],
      noAssoc: "Aucune association SR/ER n'a été créée.",
      noJustification: "Pas de justification",
    },

    w3: {
      title: "3. ATELIER 3 : SCÉNARIOS STRATÉGIQUES",
      desc: "Cet atelier a pour objectif d'analyser l'écosystème et de construire des scénarios stratégiques de risque.",
      ecoTitle: "3.1. CARTOGRAPHIE DE L'ÉCOSYSTÈME",
      stakeholdersTitle: "3.1.1. Description des parties prenantes",
      stakeholdersHeaders: ["#", "Nom", "Catégorie", "Type", "Description"],
      noStakeholders: "Aucune partie prenante décrite.",
      evalTitle: "3.1.2. ÉVALUATION DES PARTIES PRENANTES",
      evalHeaders: ["Nom", "Dép.", "Pén.", "Mat.", "Conf.", "Ret.", "Score", "Zone"],
      noEval: "Aucune évaluation disponible.",
      resStakeholderTitle: "3.1.3. Risque résiduel par partie prenante",
      resStakeholderHeaders: ["Partie Prenante", "Risque Initial", "Ancienne Zone", "Risque Résiduel", "Expression du risque résiduel", "Nouvelle Zone", "Réduction (%)"],
      noRetainedStakeholders: "Aucune partie prenante retenue pour le calcul du risque résiduel.",
      radarTitle: "3.1.4. REPRÉSENTATION DE LA CARTOGRAPHIE DE LA MENACE NUMÉRIQUE INITIALE",
      radarDesc: "Cette visualisation présente la cartographie des parties prenantes identifiées, positionnées selon leur niveau de menace et leurs caractéristiques de fiabilité cyber et d'exposition.",
      scenariosTitle: "3.2. SCÉNARIOS STRATÉGIQUES",
      noScenarios: "Aucun scénario stratégique identifié (pas de mapping SR/ER).",
      scenariosHeaders: ["ID", "Source de Risque", "Objectif Visé", "Événement Redouté", "Valeur Métier & Biens", "Mesures de Contrôle"],
      noCompleteScenarios: "Aucun scénario stratégique complet n'a pu être reconstitué.",
      attackPathsTitle: "3.3. CHEMINS D'ATTAQUE",
      noAttackPaths: "Aucun chemin d'attaque identifié.",
      attackPathsHeaders: ["Scénario", "Référence", "Source de Risque", "Objectif Visé", "Événement Redouté", "Valeur Métier", "Parties Prenantes", "Vraisemblance"],
      attackPathNote: "Note : « Étude préliminaire » = chemin traité directement en Atelier 3 (pas de scénario opérationnel en Atelier 4), vraisemblance fixée manuellement. « À évaluer (Atelier 4) » = vraisemblance déterminée par les scénarios opérationnels.",
      preliminaryStudy: "Étude préliminaire",
      toEvaluateW4: "À évaluer (Atelier 4)",
      measuresTitle: "3.4. MESURES DE SÉCURITÉ",
      noMeasures: "Aucune mesure de sécurité définie.",
      measuresHeaders: ["Titre", "Description", "Informations", "Chemins d'attaque"],
      progressionTitle: "3.5. Plan de traitement de risque atelier 3",
      progressionDesc: "Cette section présente la progression des mesures de sécurité pour chaque événement redouté, incluant les mesures d'Atelier 1 (Socle de sécurité) et d'Atelier 3 (Écosystème).",
      progressionHeaders: ["Événement Redouté", "Valeur Métier", "Biens Supports", "Mesures A1", "Mesures A3", "Progression", "Statut"],
      noProgEvents: "Aucun événement redouté trouvé.",
      progCompleted: "Terminé",
      progInProgress: "En cours",
      progNotStarted: "Non commencé",
    },

    w4: {
      title: "4. ATELIER 4 : SCÉNARIOS OPÉRATIONNELS",
      desc: "Cet atelier a pour objectif de construire les scénarios opérationnels (modes opératoires d'attaque) et d'analyser la menace numérique.",
      ctiTitle: "4.1 INTELLIGENCE DES MENACES",
      ctiDesc: "Cette section présente l'analyse de la menace numérique basée sur les biens supports identifiés (CVE, Techniques d'attaques, etc.).",
      noCtiData: "Aucune donnée d'intelligence des menaces disponible.",
      statsHeaders: ["Métrique", "Valeur"],
      statsAssetsLabel: "Total Biens Supports Analysés",
      statsCVELabel: "Total Vulnérabilités (CVE)",
      statsCriticalLabel: "Dont Critiques",
      statsTechniquesLabel: "Total Techniques (MITRE/ATLAS)",
      ctiSynthesisTitle: "Synthèse par Chemin d'Attaque / Biens Supports",
      ctiSynthesisHeaders: ["Réf", "Biens Supports", "Source de Risque", "Score", "Vulns", "Techniques Principales"],
      opScenariosTitle: "4.2 SCÉNARIOS OPÉRATIONNELS",
      opScenariosDesc: "Cette section détaille les scénarios opérationnels construits.",
      noOpScenarios: "Aucun scénario opérationnel identifié.",
    },

    w5: {
      title: "5. ATELIER 5 : TRAITEMENT DU RISQUE ET SUIVI",
      desc: "Cet atelier a pour objectif de définir la stratégie de traitement des risques, d'évaluer les risques résiduels et de suivre la mise en œuvre des mesures de sécurité.",
      noData: "Aucune donnée de traitement de risque disponible.",
      noScenarios: "Aucun scénario de risque disponible.",
      initialMatrixTitle: "MATRICE DES RISQUES INITIAL",
      residualMatrixTitle: "MATRICE DES RISQUES RÉSIDUELS",
      initialMatrixDesc: "Matrice de positionnement des risques initiaux (bruts) avant traitement.",
      residualMatrixDesc: "Matrice de positionnement des risques résiduels après prise en compte des mesures de sécurité.",
      matrixInitialDesc: "Matrice de positionnement des risques initiaux (bruts) avant traitement.",
      matrixResidualDesc: "Matrice de positionnement des risques résiduels après prise en compte des mesures de sécurité.",
      matrixAxisGravity: "Gravité",
      matrixAxisLikelihood: "Vraisemblance",
      matrixLegendLabel: "Légende :",
      matrixLevelCritical: "Critique (>=12)",
      matrixLevelMajor: "Majeur (8-11)",
      matrixLevelModerate: "Moyen (4-7)",
      matrixLevelMinor: "Mineur (1-3)",
      measuresTitle: "MESURES DE SÉCURITÉ",
      measuresDesc: "Liste des mesures de sécurité regroupées par catégorie.",
      measuresHeaders: ["Mesure", "Scénario", "Responsable", "Difficultés", "Complexité", "Budget (€)", "Charge (j/h)", "Échéance", "Priorité", "Statut"],
      scheduleTitle: "ÉCHÉANCIER DE MISE EN ŒUVRE",
      scheduleDesc: "Calendrier prévisionnel de mise en œuvre des mesures de sécurité, regroupé par période glissante (T+0, T+3, T+6, T+9, T+12).",
      scheduleHeaders: ["Mesure", "Scénario", "Responsable", "Échéance", "Charge (j/h)", "Statut"],
      treatmentTitle: "TRAITEMENT DES SCENARIOS DE RISQUE",
      treatmentDesc: "Options de traitement et evaluation du risque residuel pour chaque scenario de risque.",
      treatmentHeaders: ["Ref", "Scenario", "Option", "Resp.", "Justif.", "RR"],
      residualAnalysisTitle: "ANALYSE DU RISQUE RESIDUEL",
      residualAnalysisHeaders: ["Ref", "Description", "Vulnerabilites", "Facteurs agg.", "Mesures de suivi"],
      noResidualData: "Aucune donnee de risque residuel renseignee.",
      coverageRegistryTitle: "REGISTRE DE TRAÇABILITÉ : ÉVÉNEMENTS REDOUTÉS VS SCÉNARIOS DE RISQUE",
      coverageRegistryDesc: "Ce registre assure la traçabilité entre les événements redoutés identifiés en Atelier 1 et l'ensemble des scénarios de risque modélisés (Ateliers 3 & 4).",
      noCoverageEvents: "Aucun événement redouté répertorié.",
      coverageRegistryHeaders: ["Événement Redouté", "Gravité", "Valeur Métier", "Scénarios Rattachés", "Justification"],
      uncoveredWarning: (n) => `Attention : ${n} événement(s) redouté(s) de l'Atelier 1 ne sont rattachés à aucun scénario de risque.`,
      notAttached: "Non rattaché",
    },

    annexes: {
      title: "ANNEXES",
      desc: "Cette section présente les référentiels, échelles et définitions utilisés tout au long de l'analyse.",
      gravityScaleTitle: "ÉCHELLE DE GRAVITÉ",
      gravityScaleDesc: "Cette échelle définit les niveaux d'impact des événements redoutés.",
      gravityScaleHeaders: ["Niveau", "Description", "Impacts Types"],
      srOvTitle: "APPENDICE : CATÉGORIES DE SOURCES DE RISQUE (SR) ET D'OBJECTIFS VISÉS (OV)",
      srTitle: "Catégories de Sources de Risque (SR)",
      srTable: [
        ["Catégorie", "Description"],
        ["Étatique", "Services de renseignement, armées, groupes parrainés par un État."],
        ["Criminalité organisée", "Cybercriminels, mafias, gangs."],
        ["Terroriste", "Groupes cherchant à semer la terreur ou la déstabilisation."],
        ["Activiste", "Hacktivistes, militants politiques ou idéologiques."],
        ["Interne", "Employés, prestataires, partenaires (malveillance ou négligence)."],
        ["Concurrent", "Espionnage industriel, sabotage économique."],
      ],
      ovTitle: "Objectifs Visés (OV)",
      ovTable: [
        ["Objectif", "Description"],
        ["Lucratif", "Gain financier, vol de données monétisables, rançongiciel."],
        ["Espionnage", "Vol de secrets industriels, propriété intellectuelle, données stratégiques."],
        ["Sabotage", "Destruction, dégradation ou interruption de services/systèmes."],
        ["Destabilisation", "Atteinte à l'image, manipulation d'opinion, influence."],
      ],
      srovScaleTable: [
        ["Niveau", "Pertinence", "Critères"],
        ["3", "Élevée", "Couple très probable, motivation forte, opportunités réelles."],
        ["2", "Moyenne", "Couple plausible, motivation existante mais opportunités limitées."],
        ["1", "Faible", "Couple peu probable, motivation faible ou théorique."],
      ],
      stakeholderScaleHeaders: ["Niveau", "Dépendance / Menace", "Description"],
      stakeholderScaleRows: [
        ["Critique", "Forte", "Partie prenante indispensable ou vecteur d'attaque privilégié."],
        ["Significatif", "Moyenne", "Partie prenante importante, dépendance modérée."],
        ["Faible", "Faible", "Partie prenante secondaire ou facilement substituable."],
      ],
      glossaryTitle: "GLOSSAIRE MÉTHODE EBIOS RISK MANAGER",
      glossaryDesc: "Définition des termes principaux.",
      matrixSchemaTitle: "MATRICE DE RISQUE (SCHEMA)",
      matrixSchemaDesc: "Représentation visuelle des niveaux de risque en fonction de la Gravité et de la Vraisemblance.",
      glossaryTable: [
        ["Terme", "Définition"],
        ["Valeur Métier", "Composante importante pour l'organisation (processus, info, savoir-faire) à protéger."],
        ["Bien Support", "Élément matériel ou immatériel (serveur, réseau, logiciel) supportant une ou plusieurs valeurs métier."],
        ["Événement Redouté", "Scénario de haut niveau décrivant un impact négatif sur une valeur métier."],
        ["Scénario Stratégique", "Chemin d'attaque au niveau de l'écosystème, reliant une source de risque à un événement redouté."],
        ["Scénario Opérationnel", "Séquence technique détaillée (mode opératoire) concrétisant un scénario stratégique."],
        ["Mesure de Sécurité", "Action ou dispositif réduisant le risque (prévention, protection, récupération, etc.)."],
        ["Risque Résiduel", "Niveau de risque subsistant après l'application des mesures de traitement."],
      ],
      matrixGravityAxis: "Gravité de l'événement",
      matrixLikelihoodAxis: "Vraisemblance du scénario",
      likelihoodScalesTitle: "ÉCHELLES DE VRAISEMBLANCE (SCÉNARIOS OPÉRATIONNELS)",
      likelihoodScalesDesc: "La méthode EBIOS RM propose trois approches pour évaluer la vraisemblance des modes opératoires.",
      likelihoodExpressTitle: "1. Méthode Express",
      likelihoodExpressDesc: "Évaluation directe par jugement d'expert (niveau 1 à 4) basée sur la complexité globale de l'attaque.",
      likelihoodStandardTitle: "2. Méthode Standard",
      likelihoodStandardDesc: "Évaluation basée sur deux facteurs clés : les ressources requises par l'attaquant et la complexité technique de l'attaque. La vraisemblance est déduite d'une matrice croisant ces deux facteurs.",
      likelihoodAdvancedTitle: "3. Méthode Avancée",
      likelihoodAdvancedDesc: "Analyse fine de chaque action élémentaire du scénario. La vraisemblance globale est déterminée par le 'chemin de moindre résistance' (l'action la plus difficile détermine la difficulté globale, ou cumul des probabilités).",
    },

    lookups: {
      pillars: {
        disponibilite: "Disponibilité",
        integrite: "Intégrité",
        confidentialite: "Confidentialité",
        preuve: "Preuve",
        tracabilite: "Traçabilité",
      },
      assetTypes: {
        organisation: "Organisation",
        locaux: "Locaux",
        equipements: "Équipements",
        reseaux: "Réseaux",
        logiciels: "Logiciels",
      },
      srCategories: {
        criminel: "Criminel",
        etatique: "Étatique",
        terroriste: "Terroriste",
        activiste: "Activiste",
        professionnel: "Professionnel de l'information",
        interne: "Interne",
        vengeur: "Vengeur",
        incompetent: "Incompétent",
        curieux: "Curieux",
      },
      ovCategories: {
        lucratif: "Lucratif",
        influence: "Influence",
        entrave: "Entrave",
        ideologique: "Idéologique",
      },
      threatZones: {
        danger: "Zone de danger",
        control: "Zone de contrôle",
        watch: "Zone de veille",
        outOfScope: "Hors périmètre",
      },
      stakeholderTypes: {
        internal: "Interne",
        external: "Externe",
      },
      stakeholderCategories: {
        client: "Client",
        partner: "Partenaire",
        provider: "Fournisseur",
        technical: "Technique",
        business: "Business",
        subsidiary: "Filiale",
      },
      measureCategories: {
        governance: "GOUVERNANCE",
        protection: "PROTECTION",
        defense: "DÉFENSE",
        resilience: "RÉSILIENCE",
        other: "AUTRE",
        'gouvernance et anticipation': "Gouvernance",
      },
      measureStatuses: {
        implemented: "Fait",
        in_progress: "En cours",
        planned: "Planifié",
        abandoned: "Abandonnée",
      },
      treatmentOptions: {
        reduce: "Réduction",
        accept: "Acceptation",
        transfer: "Transfert",
        avoid: "Évitement",
      },
      periods: {
        t0: "T+0 (0 à 3 mois)",
        t3: "T+3 (3 à 6 mois)",
        t6: "T+6 (6 à 9 mois)",
        t9: "T+9 (9 à 12 mois)",
        t12: "T+12 (12 mois et +)",
        none: "Non planifié",
      },
    },
  },

  en: {
    pdfTitle: "Risk Treatment Plan",
    pdfSubject: "EBIOS RM - Risk Synthesis",
    pdfKeywords: "EBIOS RM, Matrix, Risks, Scoping, Baseline, Sources, Associations, Ecosystem, Scenarios",

    cover: {
      program: "Program:",
      analysis: "Risk Analysis – EBIOS RM",
      internal: "Internal",
      docType: "Document:",
      docTitle: "Risk Treatment Plan",
      docSubtitle: "Risk Treatment Matrix & Synthesis",
      version: "Version:",
      reference: "Reference:",
      scope: "Analysis Scope:",
      organization: "Organization:",
      date: "Date:",
      status: "Status:",
      statusValidated: "Validated",
    },

    common: {
      dash: "—",
      yes: "Yes",
      no: "No",
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical",
      done: "Done",
      inProgress: "In progress",
      planned: "Planned",
      abandoned: "Abandoned",
      infoNotAvailable: "Not provided",
      descNotAvailable: "Description not available",
      unknown: "Unknown",
    },

    summary: {
      title: "0. EXECUTIVE SUMMARY",
      studySubject: "Subject of the Study",
      studyOn: (name) => `The study focuses on: ${name}.`,
      noDesc: "No description provided.",
      assumptionsConstraints: "Main Assumptions and Constraints",
      identifiedConstraints: "Identified constraints:",
      workingAssumptions: "Working assumptions:",
      andOthers: (n) => `... (and ${n} others)`,
      noAssumptions: "No major assumptions or constraints specified.",
      initialRisks: "Inherent / Initial Risks",
      deSeverityDist: "Distribution of Feared Events by severity (before treatment):",
      severityHeaders: ["Severity", "Count"],
      catCritical: "Catastrophic / Critical",
      major: "Major",
      modMinor: "Moderate / Minor",
      treatmentPlan: "Main Elements of the Risk Treatment Plan",
      treatmentAddressesScenarios: (n) => `The treatment plan addresses ${n} strategic scenario(s).`,
      measuresInclude: "Security measures include preventive, protective, recovery, and governance controls.",
      residualRisks: "Residual Risks",
      residualWarning: (n) => `Warning: ${n} scenario(s) retain a high risk level in the medium term.`,
      residualAcceptable: "Applying the treatment plan brings all risks down to acceptable levels in the medium term.",
    },

    w1: {
      title: "1. WORKSHOP 1: SCOPE AND SECURITY BASELINE",
      infoTitle: "1.1. Study Information",
      infoHeaders: ["Information", "Value"],
      version: "Version",
      date: "Date",
      status: "Status",
      inProgress: "In progress",
      classification: "Classification",
      internal: "Internal",
      scopeTitle: "1.2. Business and Technical Scope",
      systemPresentation: "1.2.1. System Presentation",
      missions: "1.2.2. Missions",
      businessValues: "1.2.3. Business Values",
      bvDescription: "This section details the essential business values identified for the study scope, including their nature (process or information), owner, and description.",
      bvHeaders: ["Business Value", "Nature", "Owner", "Description"],
      natureProcess: "Process",
      natureInfo: "Information",
      supportingAssets: "1.2.4. Supporting Assets",
      saDescription: (n) => `This section presents the detailed inventory of the ${n} supporting assets identified, organized by business value. These technical assets represent all components necessary for the operation of the organization's business processes.`,
      saHeaders: ["ID", "Name", "Type", "Owner", "Location", "Vendor/Product", "Version"],
      saDistTitle: "Distribution by asset type:",
      generalInfo: "1.2.5. General Information",
      assumptions: "Assumptions",
      constraints: "Constraints",
      raciMatrix: "RACI Matrix",
      raciHeaders: ["Name", "Role", "Contact"],
      respControls: "Control Measure Responsible Persons",
      respHeaders: ["Position", "Role"],
      dreadedEventsSection: "1.3. Identification of Feared Events",
      dreadedEventsTitle: "1.3.1. Feared Events",
      erHeaders: ["Business Value", "Pillar", "Feared Event", "Description/Impacts", "Severity"],
      nonIntRisksTitle: "1.3.2. Non-Intentional Risks",
      rnHeaders: ["Pillar", "Non-Intentional Risk", "Description/Impacts", "Severity"],
      noDreadedEvents: "No Feared Event has been identified.",
      bvDeRelTitle: "1.4. Relationship Between Business Value Security Needs and Feared Event Severity",
      bvDeRelDesc: "The table below shows the relationship between business value (BV) security needs and Feared Event (DE) severity.",
      relHeaders: ["Business Value", "Abbr.", "Security Needs", "Feared Event Name", "Abbr.", "Severity"],
      relInsufficient: "Insufficient data to establish the relationship.",
      baselineTitle: "1.5. Security Baseline",
      baselineDesc: "The table below presents the security measures identified to address the Feared Events.",
      baselineHeaders: ["Rule / Event", "Applicability Status", "Gap Comment", "Justification", "Severity", "Control Measures", "Residual Severity"],
      rule: "Rule",
      event: "Event",
      unknown: "Unknown",
      nonIntRisk: "Non-intentional risk",
      dreadedEvent: "Feared Event",
      commentPrefix: "Comment:",
      controlPrefix: "Control",
      decisionPrefix: "Decision:",
      responsiblePrefix: "Responsible:",
      noPlan: "No treatment plan associated with the identified Feared Events.",
      noBaselineData: "No risk treatment data available (security baseline not defined).",
    },

    w2: {
      title: "2. WORKSHOP 2: RISK SOURCES AND SCENARIOS",
      desc: "The objective of this workshop is to identify risk sources and construct the identified risk scenarios.",
      sourcesTitle: "2.1. RISK SOURCES",
      sourcesDesc: "This section lists all potential malicious actors (risk sources) and their characteristics.",
      categoryPrefix: "Category: ",
      sourcesHeaders: ["Name", "Target Objective", "Type", "Motiv.", "Activ.", "Res.", "Retained"],
      noSources: "No risk source identified yet.",
      assocTitle: "2.2. RS/DE ASSOCIATIONS",
      assocDesc: "This section presents the validated associations between Risk Sources (RS) and Feared Events (DE).",
      assocHeaders: ["Risk Source", "Target Objective", "Feared Event", "Threat Level", "RS Capacities", "Retained", "Justification"],
      noAssoc: "No RS/DE association has been created.",
      noJustification: "No justification",
    },

    w3: {
      title: "3. WORKSHOP 3: STRATEGIC SCENARIOS",
      desc: "The objective of this workshop is to analyze the ecosystem and construct strategic risk scenarios.",
      ecoTitle: "3.1. ECOSYSTEM MAPPING",
      stakeholdersTitle: "3.1.1. Stakeholder Description",
      stakeholdersHeaders: ["#", "Name", "Category", "Type", "Description"],
      noStakeholders: "No stakeholders described.",
      evalTitle: "3.1.2. STAKEHOLDER EVALUATION",
      evalHeaders: ["Name", "Dep.", "Pen.", "Mat.", "Trust", "Ret.", "Score", "Zone"],
      noEval: "No evaluation available.",
      resStakeholderTitle: "3.1.3. Residual Risk by Stakeholder",
      resStakeholderHeaders: ["Stakeholder", "Initial Risk", "Previous Zone", "Residual Risk", "Residual Risk Expression", "New Zone", "Reduction (%)"],
      noRetainedStakeholders: "No retained stakeholders for residual risk calculation.",
      radarTitle: "3.1.4. REPRESENTATION OF THE INITIAL DIGITAL THREAT MAPPING",
      radarDesc: "This visualization presents the mapping of identified stakeholders, positioned according to their threat level, cyber maturity, and exposure.",
      scenariosTitle: "3.2. STRATEGIC SCENARIOS",
      noScenarios: "No strategic scenarios identified (no RS/DE mapping).",
      scenariosHeaders: ["ID", "Risk Source", "Target Objective", "Feared Event", "Business Value & Assets", "Control Measures"],
      noCompleteScenarios: "No complete strategic scenario could be reconstructed.",
      attackPathsTitle: "3.3. ATTACK PATHS",
      noAttackPaths: "No attack path identified.",
      attackPathsHeaders: ["Scenario", "Reference", "Risk Source", "Target Objective", "Feared Event", "Business Value", "Stakeholders", "Likelihood"],
      attackPathNote: "Note: 'Preliminary study' = path addressed directly in Workshop 3 (no operational scenario in Workshop 4), likelihood set manually. 'To evaluate (Workshop 4)' = likelihood determined by operational scenarios.",
      preliminaryStudy: "Preliminary study",
      toEvaluateW4: "To evaluate (Workshop 4)",
      measuresTitle: "3.4. SECURITY MEASURES",
      noMeasures: "No security measures defined.",
      measuresHeaders: ["Title", "Description", "Information", "Attack Paths"],
      progressionTitle: "3.5. Workshop 3 Risk Treatment Plan",
      progressionDesc: "This section presents the progression of security measures for each Feared Event, including Workshop 1 (Security Baseline) and Workshop 3 (Ecosystem) measures.",
      progressionHeaders: ["Feared Event", "Business Value", "Supporting Assets", "W1 Measures", "W3 Measures", "Progression", "Status"],
      noProgEvents: "No Feared Event found.",
      progCompleted: "Completed",
      progInProgress: "In progress",
      progNotStarted: "Not started",
    },

    w4: {
      title: "4. WORKSHOP 4: OPERATIONAL SCENARIOS",
      desc: "The objective of this workshop is to construct operational scenarios (attack techniques) and analyze digital threat intelligence.",
      ctiTitle: "4.1 THREAT INTELLIGENCE",
      ctiDesc: "This section presents the digital threat analysis based on identified supporting assets (CVE, Attack Techniques, etc.).",
      noCtiData: "No threat intelligence data available.",
      statsHeaders: ["Metric", "Value"],
      statsAssetsLabel: "Total Supporting Assets Analyzed",
      statsCVELabel: "Total Vulnerabilities (CVE)",
      statsCriticalLabel: "Of which Critical",
      statsTechniquesLabel: "Total Techniques (MITRE/ATLAS)",
      ctiSynthesisTitle: "Summary by Attack Path / Supporting Assets",
      ctiSynthesisHeaders: ["Ref", "Supporting Assets", "Risk Source", "Score", "Vulns", "Top Techniques"],
      opScenariosTitle: "4.2 OPERATIONAL SCENARIOS",
      opScenariosDesc: "This section details the operational scenarios constructed.",
      noOpScenarios: "No operational scenario identified.",
    },

    w5: {
      title: "5. WORKSHOP 5: RISK TREATMENT AND MONITORING",
      desc: "The objective of this workshop is to define the risk treatment strategy, assess residual risks, and monitor the implementation of security measures.",
      noData: "No risk treatment data available.",
      noScenarios: "No risk scenarios available.",
      initialMatrixTitle: "INITIAL RISK MATRIX",
      residualMatrixTitle: "RESIDUAL RISK MATRIX",
      initialMatrixDesc: "Positioning matrix of initial (inherent) risks before treatment.",
      residualMatrixDesc: "Positioning matrix of residual risks after taking security measures into account.",
      matrixInitialDesc: "Positioning matrix of initial (inherent) risks before treatment.",
      matrixResidualDesc: "Positioning matrix of residual risks after taking security measures into account.",
      gravity: "Severity",
      likelihood: "Likelihood",
      legend: "Legend:",
      criticalRisk: "Critical (>=12)",
      majorRisk: "Major (8-11)",
      mediumRisk: "Medium (4-7)",
      minorRisk: "Minor (1-3)",
      matrixAxisGravity: "Severity",
      matrixAxisLikelihood: "Likelihood",
      matrixLegendLabel: "Legend:",
      matrixLevelCritical: "Critical (>=12)",
      matrixLevelMajor: "Major (8-11)",
      matrixLevelModerate: "Medium (4-7)",
      matrixLevelMinor: "Minor (1-3)",
      secMeasuresTitle: "SECURITY MEASURES",
      secMeasuresDesc: "List of security measures grouped by category.",
      secMeasuresHeaders: ["Measure", "Scenario", "Responsible", "Obstacles", "Complexity", "Budget (€)", "Workload (d/h)", "Deadline", "Priority", "Status"],
      measuresTitle: "SECURITY MEASURES",
      measuresDesc: "List of security measures grouped by category.",
      measuresHeaders: ["Measure", "Scenario", "Responsible", "Obstacles", "Complexity", "Budget (€)", "Workload (d/h)", "Deadline", "Priority", "Status"],
      roadmapTitle: "IMPLEMENTATION SCHEDULE",
      roadmapDesc: "Forecast schedule for implementing security measures, grouped by rolling period (T+0, T+3, T+6, T+9, T+12).",
      roadmapHeaders: ["Measure", "Scenario", "Responsible", "Deadline", "Workload (d/h)", "Status"],
      scheduleTitle: "IMPLEMENTATION SCHEDULE",
      scheduleDesc: "Forecast schedule for implementing security measures, grouped by rolling period (T+0, T+3, T+6, T+9, T+12).",
      scheduleHeaders: ["Measure", "Scenario", "Responsible", "Deadline", "Workload (d/h)", "Status"],
      treatmentTitle: "RISK SCENARIOS TREATMENT",
      treatmentDesc: "Treatment options and residual risk evaluation for each risk scenario.",
      treatmentHeaders: ["Ref", "Scenario", "Option", "Resp.", "Justif.", "RR"],
      residualAnalysisTitle: "RESIDUAL RISK ANALYSIS",
      residualAnalysisHeaders: ["Ref", "Description", "Vulnerabilities", "Aggravating Factors", "Monitoring Measures"],
      noResidualData: "No residual risk data provided.",
      coverageTitle: "TRACEABILITY REGISTER: Feared EventS VS RISK SCENARIOS",
      coverageDesc: "This register ensures traceability between the Feared Events identified in Workshop 1 and all modeled risk scenarios (Workshops 3 & 4).",
      coverageHeaders: ["Feared Event", "Severity", "Business Value", "Attached Scenarios", "Justification"],
      coverageRegistryTitle: "TRACEABILITY REGISTER: Feared EventS VS RISK SCENARIOS",
      coverageRegistryDesc: "This register ensures traceability between the Feared Events identified in Workshop 1 and all modeled risk scenarios (Workshops 3 & 4).",
      noCoverageEvents: "No Feared Events recorded.",
      coverageRegistryHeaders: ["Feared Event", "Severity", "Business Value", "Attached Scenarios", "Justification"],
      uncoveredWarning: (n) => `Warning: ${n} Feared Event(s) from Workshop 1 are not attached to any risk scenario.`,
      notAttached: "Not attached",
    },

    annexes: {
      title: "ANNEXES",
      desc: "This section presents the frameworks, scales, and definitions used throughout the analysis.",
      gravityScaleTitle: "SEVERITY SCALE",
      gravityScaleDesc: "This scale defines the impact levels of Feared Events.",
      gravityScaleHeaders: ["Level", "Description", "Typical Impacts"],
      srOvTitle: "APPENDIX: RISK SOURCE (RS) AND TARGET OBJECTIVE (TO) CATEGORIES",
      srTitle: "Risk Source (RS) Categories",
      srTable: [
        ["Category", "Description"],
        ["State-sponsored", "Intelligence services, military, state-sponsored groups."],
        ["Organized crime", "Cybercriminals, mafias, gangs."],
        ["Terrorist", "Groups seeking to create terror or destabilization."],
        ["Activist", "Hacktivists, political or ideological militants."],
        ["Insider", "Employees, contractors, partners (malice or negligence)."],
        ["Competitor", "Industrial espionage, economic sabotage."],
      ],
      ovTitle: "Target Objectives (TO)",
      ovTable: [
        ["Objective", "Description"],
        ["Financial", "Financial gain, theft of monetizable data, ransomware."],
        ["Espionage", "Theft of trade secrets, intellectual property, strategic data."],
        ["Sabotage", "Destruction, degradation, or disruption of services/systems."],
        ["Destabilization", "Reputational damage, public opinion manipulation, influence."],
      ],
      srovScaleTable: [
        ["Level", "Relevance", "Criteria"],
        ["3", "High", "Very probable pair, high motivation, real opportunities."],
        ["2", "Medium", "Plausible pair, existing motivation but limited opportunities."],
        ["1", "Low", "Unlikely pair, low or theoretical motivation."],
      ],
      stakeholderScaleHeaders: ["Level", "Dependency / Threat", "Description"],
      stakeholderScaleRows: [
        ["Critical", "High", "Essential stakeholder or primary attack vector."],
        ["Significant", "Medium", "Important stakeholder, moderate dependency."],
        ["Low", "Low", "Secondary or easily replaceable stakeholder."],
      ],
      glossaryTable: [
        ["Term", "Definition"],
        ["Business Value", "Key component for the organization (process, information, know-how) to protect."],
        ["Supporting Asset", "Tangible or intangible asset (server, network, software) supporting business values."],
        ["Feared Event", "High-level scenario describing a negative impact on a business value."],
        ["Strategic Scenario", "Attack path at the ecosystem level, linking a risk source to a Feared Event."],
        ["Operational Scenario", "Detailed technical sequence (attack path) realizing a strategic scenario."],
        ["Security Measure", "Action or control reducing risk (prevention, protection, recovery, etc.)."],
        ["Residual Risk", "Remaining risk level after applying risk treatment measures."],
      ],
      matrixGravityAxis: "Event Severity",
      matrixLikelihoodAxis: "Scenario Likelihood",
      likelihoodExpressTitle: "1. Express Method",
      likelihoodExpressDesc: "Direct evaluation by expert judgment (level 1 to 4) based on the overall complexity of the attack.",
      likelihoodStandardTitle: "2. Standard Method",
      likelihoodStandardDesc: "Evaluation based on two key factors: resources required by the attacker and the technical complexity of the attack. Likelihood is derived from a matrix crossing these two factors.",
      likelihoodAdvancedTitle: "3. Advanced Method",
      likelihoodAdvancedDesc: "Detailed analysis of each elementary action in the scenario. Overall likelihood is determined by the 'path of least resistance' (the most difficult action determines overall difficulty, or cumulative probability).",
    },

    lookups: {
      pillars: {
        disponibilite: "Availability",
        integrite: "Integrity",
        confidentialite: "Confidentiality",
        preuve: "Proof",
        tracabilite: "Traceability",
      },
      assetTypes: {
        organisation: "Organization",
        locaux: "Premises",
        equipements: "Hardware",
        reseaux: "Networks",
        logiciels: "Software",
      },
      srCategories: {
        criminel: "Criminal",
        etatique: "State-sponsored",
        terroriste: "Terrorist",
        activiste: "Activist",
        professionnel: "Information Broker",
        interne: "Insider",
        vengeur: "Disgruntled",
        incompetent: "Incompetent",
        curieux: "Curious",
      },
      ovCategories: {
        lucratif: "Financial",
        influence: "Influence",
        entrave: "Disruption",
        ideologique: "Ideological",
      },
      threatZones: {
        danger: "Danger Zone",
        control: "Control Zone",
        watch: "Watch Zone",
        outOfScope: "Out of Scope",
      },
      stakeholderTypes: {
        internal: "Internal",
        external: "External",
      },
      stakeholderCategories: {
        client: "Client",
        partner: "Partner",
        provider: "Supplier",
        technical: "Technical",
        business: "Business",
        subsidiary: "Subsidiary",
      },
      measureCategories: {
        governance: "GOVERNANCE",
        protection: "PROTECTION",
        defense: "DEFENSE",
        resilience: "RESILIENCE",
        other: "OTHER",
        'gouvernance et anticipation': "Governance",
      },
      measureStatuses: {
        implemented: "Done",
        in_progress: "In progress",
        planned: "Planned",
        abandoned: "Abandoned",
      },
      treatmentOptions: {
        reduce: "Reduction",
        accept: "Acceptance",
        transfer: "Transfer",
        avoid: "Avoidance",
      },
      periods: {
        t0: "T+0 (0 to 3 mos)",
        t3: "T+3 (3 to 6 mos)",
        t6: "T+6 (6 to 9 mos)",
        t9: "T+9 (9 to 12 mos)",
        t12: "T+12 (12+ mos)",
        none: "Unscheduled",
      },
    },
  },
};

